











































































































import Vue, { PropType } from 'vue'
import axios from 'axios'
import SubmitButton from '../atoms/SubmitButton.vue'
import MessageButton, { constructJsAudioPlayer, destructJsAudioPlayer } from '../atoms/MessageButton.vue'
import { TestInfo } from '../../utils/service/KoushiSite'
import ExmasForTensakuVisiter from '../../utils/ExmasForTensakuVisiter'

// 内部制御用のステータス
type InternalStatus = 'NOT_SUBMITTED' | 'SUBMITTED' | 'REQUEST_RESUBMIT' | 'COMPLETED'


export type DataType = {
  width: number | null
}

const priv = {
  // 日付を表す文字列を表示用に整形 0埋めしないので注意
  formatDateStr(date: string): string {
    const splitted = date.split(/[^0-9]/)
    const year = splitted[0]
    const month = splitted[1]
    const day = splitted[2]
    return `${year}/${month}/${day}`
  },
  dateToStr(date: Date): string {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    return `${year}/${month}/${day}`
  },
  parseDate(date: string): Date {
    const splitted = date.split(/[^0-9]/)
    const year = parseInt(splitted[0])
    const month = parseInt(splitted[1])
    const day = parseInt(splitted[2])
    return new Date(year, month-1, day)
  },
  parseTime(time: string): Date {
    const splitted = time.split(/[^0-9]/)
    const year = parseInt(splitted[0])
    const month = parseInt(splitted[1])
    const day = parseInt(splitted[2])
    const hour = splitted.length > 3 ? parseInt(splitted[3]) : 0
    const min = splitted.length > 4 ? parseInt(splitted[4]) : 0
    const sec = splitted.length > 5 ? parseInt(splitted[5]) : 0
    return new Date(year, month-1, day, hour, min, sec)
  },
}

export default Vue.extend({
  components: {
    SubmitButton,
    MessageButton,
  },
  props: {
    // 表示するテスト情報
    testInfo: {
      type: Array as PropType<TestInfo[]>, // TestInfo[]
      required: true
    },
    // 提出ボタン押下時、submit イベント
  },
  data(): DataType {
    return {
      width: null,
    }
  },
  beforeDestroy() {
    destructJsAudioPlayer()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  watch: {
    testInfo() {
      if (this.testInfo.length > 0) {
        // ボタンの初期化処理はテストを表示した後に行う必要があるためmountedではなくここでやる
        destructJsAudioPlayer()
        constructJsAudioPlayer()
      }
    },
  },
  computed: {
    currentDate(): Date {
      if (this.$store.state.currentDate) {
        return priv.parseDate(this.$store.state.currentDate)
      } else {
        return new Date()
      }
    },
    displayForMember(): boolean {
      return this.$store.state.isMemberPage
    },
    filteredTestInfo(): TestInfo[] {
      // 提出開始日が１週間以上未来の情報は行として表示しないようにする
      const futureDate = new Date(this.currentDate)
      // TODO: DEBUG 動作確認用に提出開始が２ヶ月先のテストまでは表示するようにする
      // futureDate.setDate(futureDate.getDate() + 7)
      futureDate.setDate(futureDate.getDate() + 60)

      return this.testInfo
        .filter(x => priv.parseDate(x.submit_period_from) < futureDate)
    },
  },
  methods: {
    handleResize(): void {
      this.width = window.innerWidth;
    },
    getDisplayStatus(info: TestInfo): string {
      const status = this.getTotalStatus(info)
      if (status === 'REQUEST_RESUBMIT') {
        let sideMessage = ''
        const isAlreadySubmitted = info.individual_data.map(x => x.status === '提出済み' || x.status === '再提出' || x.status === '確認済み')
        if (!isAlreadySubmitted[0] && !isAlreadySubmitted[1]) {
          // 全部再提出になっている場合は注記なし
        } else if (!isAlreadySubmitted[0]) {
          sideMessage = '(表面のみ)'
        } else if (!isAlreadySubmitted[1]) {
          sideMessage = '(裏面のみ)'
        }
        return '再提出ご依頼中' + sideMessage
      }
      if (status === 'NOT_SUBMITTED') {
        return '未提出'
      }
      if (status === 'SUBMITTED') {
        return '提出済み'
      }
      return '返却済み'
    },
    getTotalStatus(info: TestInfo): InternalStatus {
      if (info.individual_data.some(x => x.status === '差し戻し')) {
        return 'REQUEST_RESUBMIT'
      }
      if (info.individual_data.some(x => x.status === '未提出')) {
        return 'NOT_SUBMITTED'
      }
      if (info.individual_data.some(x => x.status === '提出済み' || x.status === '再提出' || x.status === '確認済み' )) {
        return 'SUBMITTED'
      }
      return 'COMPLETED'
    },
    getChipClass(info: TestInfo) {
      const colors: {[key in InternalStatus]: string}  = {
        'NOT_SUBMITTED': 'status__non-submit',
        'SUBMITTED': 'status__submitted',
        'REQUEST_RESUBMIT': 'status__re-submit',
        'COMPLETED': 'status__complete',
      }
      return colors[this.getTotalStatus(info)]
    },
    submit(info: TestInfo) {
      this.$emit('submit', info)
    },
    getSubmitDateStr(info: TestInfo): string {
      const submitDates = info.individual_data
        .map(x => x.submit_date)
        .filter(x => x)
        .map(x => priv.parseDate(x!))
      const latest = submitDates.reduce(
        (a, b) => a > b ? a : b
      )
      if (latest) {
        return priv.dateToStr(latest)
      } else {
        return ''
      }
    },
    isSubmitable(info: TestInfo): boolean {
      if (['NOT_SUBMITTED', 'REQUEST_RESUBMIT'].includes(this.getTotalStatus(info))) {
        if (!this.isOutOfDate(info)) {
          return true
        }
      }
      return false
    },
    isProductionMode(): boolean {
      return process.env.NODE_ENV === 'production'
    },
    isTestSubmitable(info: TestInfo): boolean {
      if (['NOT_SUBMITTED', 'REQUEST_RESUBMIT'].includes(this.getTotalStatus(info))) {
        if (!this.isProductionMode() && !this.isBeforeSubmitPeriod(info)) {
          return true
        }
      }
      return false
    },
    isSubmitted(info: TestInfo): boolean {
      return info.individual_data.some(x => x.submit_date)
    },
    isOutOfDate(info: TestInfo): boolean {
      if (this.isBeforeSubmitPeriod(info) || this.isAfterSubmitPeriod(info)) {
        return true
      }
      return false
    },
    isBeforeSubmitPeriod(info: TestInfo): boolean {
      if (info.submit_period_from && priv.parseDate(info.submit_period_from) > this.currentDate) {
        return true
      }
      return false
    },
    isAfterSubmitPeriod(info:TestInfo): boolean {
      if (info.submit_period_to && priv.parseDate(info.submit_period_to) < this.currentDate) {
        return true
      }
      return false
    },
    // 解説の一律公開日を過ぎているか
    isExplanationPublished(info: TestInfo): boolean {
      if (!this.displayForMember) return false
      // 指定がない場合は解説一律表示はしない
      if (!info.open_answer_pdf) return false

      const today = new Date(this.$store.state.currentDate)
      const open = priv.parseTime(info.open_answer_pdf)
      return open <= today
    },
    hasResult(info: TestInfo): boolean {
      const ret =
        this.getTotalStatus(info) == 'COMPLETED' ||
        this.isExplanationPublished(info)
      return ret
    },
    hasAnswerPdf(info: TestInfo): boolean {
      const ret = this.getTotalStatus(info) == 'COMPLETED'
      return ret
    },
    hasAdviceSheet(info: TestInfo): boolean {
      const ret = this.getTotalStatus(info) == 'COMPLETED'
      const examType = ExmasForTensakuVisiter[info.exam_group_key]?.type || 'MAGAZINE'
      return ret && examType == 'MAGAZINE'
    },
    hasMessage(info: TestInfo): boolean {
      return !!info.data_key
    },
    answerPdf(info: TestInfo): string {
      return `${process.env.VUE_APP_API_ENDPOINT}/api/v1/submit/tests/${info.exam_group_key}/pdf/answer`
    },
    explanationPdf(info: TestInfo): string | null {
      return `${process.env.VUE_APP_API_ENDPOINT}/api/v1/submit/tests/${info.exam_group_key}/pdf/true_answer`
    },
    advicePdf(info: TestInfo): string | null {
      // SP用アドバイスPDF
      return `${process.env.VUE_APP_API_ENDPOINT}/api/v1/submit/tests/${info.exam_group_key}/pdf/advice_sp`
    },
    getTestTypeName(info: TestInfo): string {
      let testTypeName
      if (info.name.includes('思考力')) {
        testTypeName = '小学館思考力テスト'
      } else if (info.name.includes('実力診断')) {
        testTypeName = '学年末実力診断テスト'
      } else {
        testTypeName = info.name
      }
      return testTypeName
    },
    getTestName(info: TestInfo): string {
      const testTypeName = this.getTestTypeName(info)
      if (this.displayForMember) {
        return `${info.month}月号 ${testTypeName}`
      } else {
        return testTypeName
      }
    },
    // PDFをブラウザでクリックしたのと同じ動作をする
    async getPdf(remotepath: string, filename: string) {
      try {
        const res = await axios.get(remotepath, { responseType: 'blob', dataType: 'binary' })
        const blob = new Blob([res.data], { type: 'application/pdf' })

        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        // if (this.isControlledPdf || this.isPdf) link.setAttribute('target', '_blank');
        link.click()
      } catch (e) {
        return { status: 'error', message: e }
      }
    },
    downloadAnswerPdf(info: TestInfo): void {
      this.getPdf(this.answerPdf(info), `${this.getTestName(info)}_添削済みテスト.pdf`)
    },
    downloadAdvicePdf(info: TestInfo): void {
      // 会員の場合はgoogle analytics 対応
      if (this.displayForMember) this.sendGoogleAnalytics(info, 'アドバイスシート')
      this.getPdf(this.advicePdf(info)!, `${this.getTestName(info)}_アドバイス.pdf`)
    },
    downloadExplanationPdf(info: TestInfo): void {
      this.getPdf(this.explanationPdf(info)!, `${this.getTestName(info)}_答えと解説.pdf`)
    },
    hankaku2Zenkaku(str: string): string {
      return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
    },
    sendGoogleAnalytics(info: TestInfo, btnName: 'アドバイスシート' | '提出する'): void{
      let testName
      if (info.name.includes('思考力')) {
        testName = '思考力テスト'
      } else if (info.name.includes('実力診断')) {
        testName = '実力診断テスト'
      }
      (window as any).dataLayer.push({
        "eventCategory_click": `${testName}_${info.nendo + '年度'} ${this.hankaku2Zenkaku(info.course_name)}コース`,
        "eventAction_click": `${testName}_${info.month + '月号'} ${this.getTestTypeName(info)}`,
        "eventLabel_click": `${testName}_${btnName}`,
        "event": "click_tensaku"
      });
    },
    messageDataKey(info: TestInfo): string {
      return info.data_key
    },
  },
})
